import { CrudList } from '../shared/CrudPage';
import { stockAdjustmentService } from '@kss/api';
import type { StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter } from '@kss/api';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllStockAdjustments() {
  return (
    <CrudList<StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter>
      title="Stock adjustments" newLabel="New adjustment" service={stockAdjustmentService}
      idKey="stockAdjustmentId" labelKey="adjustmentNumber" basePath="/panel/stock-adjustments"
      // Newest adjustment on top — order-like grid. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'adjustmentDate', direction: 'desc' }}
      columns={[
        { accessor: 'adjustmentNumber', title: 'Adjustment #', sortable: true, filterable: true, width: 160 },
        { accessor: 'adjustmentDate', title: 'Date', sortable: true, render: (r) => r.adjustmentDate ? new Date(r.adjustmentDate).toLocaleDateString() : '—' },
        { accessor: 'warehouseId', title: 'Warehouse', render: (r) => <NameCell kind="warehouse" id={r.warehouseId} /> },
        { accessor: 'reason', title: 'Reason', render: (r) => r.reason ?? '—' },
        { accessor: 'notes', title: 'Notes', render: (r) => r.notes ?? '—' },
      ]}
    />
  );
}
